import { computed, onUnmounted, ref } from 'vue'

const allBounds = ref(new Map<symbol, { x: number; right: number }>())

export function useFloorBounds() {
  const id = Symbol()

  function report(x: number, right: number) {
    const next = new Map(allBounds.value)
    next.set(id, { x, right })
    allBounds.value = next
  }

  onUnmounted(() => {
    const next = new Map(allBounds.value)
    next.delete(id)
    allBounds.value = next
  })

  const sharedX = computed(() => {
    if (!allBounds.value.size) return null
    return Math.min(...[...allBounds.value.values()].map(b => b.x))
  })

  const sharedRight = computed(() => {
    if (!allBounds.value.size) return null
    return Math.max(...[...allBounds.value.values()].map(b => b.right))
  })

  const sharedWidth = computed(() =>
    sharedX.value !== null && sharedRight.value !== null
      ? sharedRight.value - sharedX.value
      : null,
  )

  return { report, sharedX, sharedWidth }
}
